import { render, staticRenderFns } from "./ProductPackingGen.vue?vue&type=template&id=06422908"
import script from "./ProductPackingGen.vue?vue&type=script&lang=js"
export * from "./ProductPackingGen.vue?vue&type=script&lang=js"
import style0 from "./ProductPackingGen.vue?vue&type=style&index=0&id=06422908&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports